import { DocumentViewListPage } from "./_DocumentViewListPage";
import { fetchDocumentsIncoming, fetchDocumentsOutgoing } from "@/features/document/api";

/**
 * Văn bản cá nhân — hệ cũ là màn 2 tab "Văn bản đã nhận | Văn bản đã gửi"
 * (DocumentDAO.search type=1 và type=3), không phải danh sách văn bản do mình tạo.
 */
export function DocumentsListPage() {
  return (
    <DocumentViewListPage
      title="Văn bản cá nhân"
      breadcrumb="Quản lý Văn bản › Văn bản cá nhân"
      queryKey="documents-personal"
      tabs={[
        { key: "received", label: "Văn bản đã nhận", fetcher: fetchDocumentsIncoming },
        { key: "sent", label: "Văn bản đã gửi", fetcher: fetchDocumentsOutgoing },
      ]}
    />
  );
}
